import { LocalizationService } from 'services/LocalizationService'

export default class GambleTitle extends PIXI.Text {
  constructor(data) {
    super(LocalizationService.get(data.text), data.style)
    this._data = data
    this._titleText = LocalizationService.get(data.text)

    this.anchor.set(0.5, 0.5)
    this.name = data.name
  }

  get data(){
    return this._data
  }

  checkSize() {
    if (this.width > this.data.width && this.style.fontSize > 1) {
      this.resize()
    }
  }

  resize() {
    this.style.fontSize--
    this.checkSize()
  }
  /**
     * The distance between two points
     * @param {String} value
     * @private
     */
  update(value) {
    this.text = value
    this.style.fontSize = this.data.style.fontSize
    this.checkSize()
  }

  updateTextKey(value) {
    this.text = LocalizationService.get(value)
    this.style.fontSize = this.data.style.fontSize
    this.checkSize()
  }

  /**
   * The distance between two points
   * @param {String} value
   * @private
   */
  updateValueWithText( value) {
    this.text = `${this._titleText} ${value}`
    this.style.fontSize = this.data.style.fontSize
    this.checkSize()
  }
}
